import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { downloadTemporaryFileRequest } from "../../../../utils/APICalls";

export default function InspectorPhotosList({ photoData }: any) {
  const [photoUrl, setPhotoUrl] = useState("");
  const [description, setDescription] = useState<string | null>(null);

  useEffect(() => {
    if (photoData) {
      getPhotoUrl(photoData?.key);
      setDescription(photoData?.description);
    }
  }, [photoData]);

  const getPhotoUrl = async (key: string) => {
    const response = await downloadTemporaryFileRequest(key);
    console.log(response);
    if (response && response.data) {
      setPhotoUrl(response.data);
    }
  };

  return (
    <Box sx={{ display: "flex", mt: 1, width: "100%" }}>
      <Box
        sx={{
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          height: 100,
          position: "relative",
        }}
      >
        {!photoUrl ? (
          <CircularProgress
            size={24}
            sx={{ position: "absolute", top: "45%", left: "45%" }}
          />
        ) : (
          <Box
            component="img"
            src={photoUrl}
            alt="Photo"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        )}
      </Box>
      <Typography ml={2}>{description || "-"}</Typography>
    </Box>
  );
}
